import Router from './util/Router';
import workshopV2Common from './routes/workshopv2/workshop-v2-common';
import workshopV2Two from './routes/workshopv2/workshop-v2-two-setup';

/** Populate Router instance with DOM routes */
const routes = new Router({
  workshopV2Common,
  workshopV2Two,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
